import { returnRiskSegment } from "Pages/SyllabusCompliances/SyllabusComplianceBatchTable";
import {
  calculatePercentage,
  capitalizeFirstCharaterOfString,
  roundToAnyDecimalPlaces,
} from "utilFunctions/helperFunctions/utilFunctions";
import { displayNumberWithDecimals } from "Pages/BranchHealth/BranchHealthTable";
import styled from "styled-components";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
export interface CourseSubjectListingInterface {
  item: any;
  selectedCourseSyllabus: any;
  selectedCourseSyllabusHandler?: any;
}
const SubjectListingDiv = styled<any>("div")`
    width: 100% !important;
    overflow-x: auto !important;
    display: flex;
    flex-direction: row;
    gap: 12px;
    padding-bottom: ${({ screen }: any) =>
      ["xs", "sm", "md"].includes(screen) ? "12px" : "0px"};
}
`;
const CourseSubjectListing = ({
  item,
  selectedCourseSyllabus,
  selectedCourseSyllabusHandler,
}: CourseSubjectListingInterface) => {
  const { screen }: any = useWindowSize();
  const ReturnSubjectName = (ele: any) => {
    console.log(selectedCourseSyllabus, "selectedCourseSyllabus", ele);
    if (selectedCourseSyllabus && selectedCourseSyllabus?.subj === ele?.subj) {
      return ele?.subj;
    }
    return capitalizeFirstCharaterOfString(ele?.subj);
  };
  return (
    <SubjectListingDiv screen={screen}>
      {item.map((ele: any) => {
        return (
          <div
            key={ele?.courseId + ele?.subj}
            onClick={() => {
              selectedCourseSyllabusHandler(ele);
            }}
            className="subjectListingSubDiv"
          >
            {returnRiskSegment(
              roundToAnyDecimalPlaces(
                Number(
                  displayNumberWithDecimals(
                    calculatePercentage(
                      ele.markedPlLecCount,
                      ele.totalPlLecCount
                    )
                  )
                ),
                0
              ),
              ele?.subj &&
                ReturnSubjectName(ele) +
                  " : " +
                  roundToAnyDecimalPlaces(
                    Number(
                      displayNumberWithDecimals(
                        calculatePercentage(
                          ele.markedPlLecCount,
                          ele.totalPlLecCount
                        )
                      )
                    ),
                    0
                  ) +
                  " %",
              selectedCourseSyllabus &&
                selectedCourseSyllabus?.subj === ele?.subj
                ? false
                : true
            )}
          </div>
        );
      })}
    </SubjectListingDiv>
  );
};
export default CourseSubjectListing;
